import "bulma/css/bulma.min.css";
import "../css/app.css";

import Alpine from "@alpinejs/csp";

window.Alpine = Alpine

Alpine.data("orderItems", () => ({
    items: [0],
    nextIndex: 1,

    addItem() {
      this.items.push(this.nextIndex)
      this.nextIndex++
    },

    removeItem(index) {
      this.items = this.items.filter(i => i !== index)
    },

    itemName(index, field) {
      return `order-items-${index}-${field}`
    }
}))

Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Add a click event on each of them
  $navbarBurgers.forEach( el => {
    el.addEventListener('click', () => {

      // Get the target from the "data-target" attribute
      const target = el.dataset.target;
      const $target = document.getElementById(target);

      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      el.classList.toggle('is-active');
      $target.classList.toggle('is-active');

    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
    const $notification = $delete.parentNode;

    $delete.addEventListener('click', () => {
      $notification.parentNode.removeChild($notification);
    });
  });
});
